module.exports = __webpack_public_path__ + "static/media/projet.59281a20.jpg";